(function ($) {
    $(document).ready(function () {
        $('.wc-tab-title').addClass('closed')

        $('.wc-tab-title').on('click', function () {
            $(this).toggleClass('closed').toggleClass('opened')
            var panel = $(this).next('.wc-tab-panel')
            $(this).toggleClass('active')

            if (panel.css('display') === 'none') {
                panel.slideDown(200)
                $(this).removeClass('closed').addClass('opened')
            } else {
                panel.slideUp(200)
                $(this).removeClass('opened').addClass('closed')
            }
        })
    })
})(jQuery)
